<template>
  <div class="video-crawler-configuration-container">
    <div class="video-crawler-configuration" v-if="payload">
      <h5>Video Crawler Configuration</h5>
      <label>ตั้งค่าของ Crawler ว่าจะดึงข้อมูลวิดีโอมาจาก Tag ใดใน HTML Source</label>
      <div class="loading-state" v-if="state.isLoading">
      </div>
      <div class="config-container" v-if="!state.isLoading && shouldShowCrawlerConfig">
        <div class="config-group">
          <div class="mt-2"><b>Title</b></div>
          <div class="video-crawler-configuration__option row">
            <div class="col-md-2">
              <small>Tag</small>
              <select class="custom-select" v-model="payload.title.tag">
                <option value="h1">h1</option>
                <option value="h2">h2</option>
                <option value="meta">meta</option>
              </select>
            </div>
            <div class="col-md-5">
              <small>Attribute Key (optional)</small>
              <TextInput
                :name="'attributeKey'"
                :placeholder="'-'"
                :value="payload.title.attributeKey"
                @change="onChangeTitle" />
            </div>
            <div class="col-md-5">
              <small>Attribute Value (optional)</small>
              <TextInput
                :name="'attributeValue'"
                :placeholder="'-'"
                :value="payload.title.attributeValue"
                @change="onChangeTitle" />
            </div>
          </div>
          <VideoCrawlerTagExample
            :tag="payload.title.tag"
            :attributeKey="payload.title.attributeKey"
            :attributeValue="payload.title.attributeValue" />
        </div>
        <div class="config-group">
          <div class="mt-2"><b>Subtitle</b></div>
          <div class="video-crawler-configuration__option row">
            <div class="col-md-2">
              <small>Tag</small>
              <select class="custom-select" v-model="payload.subTitle.tag">
                <option value="h1">h1</option>
                <option value="h2">h2</option>
                <option value="meta">meta</option>
              </select>
            </div>
            <div class="col-md-5">
              <small>Attribute Key (optional)</small>
              <TextInput
                :name="'attributeKey'"
                :placeholder="'-'"
                :value="payload.subTitle.attributeKey"
                @change="onChangeSubtitle" />
            </div>
            <div class="col-md-5">
              <small>Attribute Value (optional)</small>
              <TextInput
                :name="'attributeValue'"
                :placeholder="'-'"
                :value="payload.subTitle.attributeValue"
                @change="onChangeSubtitle" />
            </div>
          </div>
          <VideoCrawlerTagExample
            :tag="payload.subTitle.tag"
            :attributeKey="payload.subTitle.attributeKey"
            :attributeValue="payload.subTitle.attributeValue" />
        </div>
        <div class="config-group">
          <div class="mt-2"><b>Cover Image Url</b></div>
          <div class="video-crawler-configuration__option row">
            <div class="col-md-2">
              <small>Tag</small>
              <select class="custom-select" v-model="payload.coverImageUrl.tag">
                <option value="h1">h1</option>
                <option value="h2">h2</option>
                <option value="meta">meta</option>
              </select>
            </div>
            <div class="col-md-5">
              <small>Attribute Key (optional)</small>
              <TextInput
                :name="'attributeKey'"
                :placeholder="'-'"
                :value="payload.coverImageUrl.attributeKey"
                @change="onChangeCoverImageUrl" />
            </div>
            <div class="col-md-5">
              <small>Attribute Value (optional)</small>
              <TextInput
                :name="'attributeValue'"
                :placeholder="'-'"
                :value="payload.coverImageUrl.attributeValue"
                @change="onChangeCoverImageUrl" />
            </div>
          </div>
          <VideoCrawlerTagExample
            :tag="payload.coverImageUrl.tag"
            :attributeKey="payload.coverImageUrl.attributeKey"
            :attributeValue="payload.coverImageUrl.attributeValue" />
        </div>
      </div>
      <div class="config-container-warning" v-if="!state.isLoading && !shouldShowCrawlerConfig">
        <span class="text-danger">*** ไม่สามารถปรับตั้งค่า Crawler ของโปรเจคท์นี้ได้ กรุณาติดต่อทีมงาน ByteArk ***</span>
      </div>
      <div class="crawler-testing-container">
        <VideoCrawlerTesting
          class="mt-4"
          :project="project"
          :crawler="crawler"
          :mapPayloadToCrawlAttributes="mapPayloadToCrawlAttributes"
          :setReadyToSave="setReadyToSave"/>
      </div>
      <FormFooter v-if="shouldShowCrawlerConfig">
        <Button @click="onSaveCrawler" :disabled="!state.readyToSave">
          <span>{{ state.isLoading ? '' : 'Save' }}</span>
          <span class="spinner-border spinner-border-sm" role="status" v-if="state.isLoading" />
        </Button>
        <span
          class="pl-3 text-danger"
          v-if="!state.readyToSave">
          * กรุณาทดสอบการใช้งาน Crawler ก่อน Save การตั้งค่า
        </span>
        <span
          class="pl-3 text-success"
          v-if="state.isSaved">
          <i class="fa fa-check" />
        </span>
      </FormFooter>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { editCrawlerSettings } from '@/project/api';

import TextInput from '@/form/TextInput.vue';
import Button from '@/form/Button.vue';
import VideoCrawlerTesting from '@/project/videoCrawler/VideoCrawlerTesting.vue';
import VideoCrawlerTagExample from '@/project/videoCrawler/VideoCrawlerTagExample.vue';
import FormFooter from '@/form/FormFooter.vue';

export default {
  props: ['project', 'initialCrawler'],
  components: {
    TextInput,
    Button,
    VideoCrawlerTesting,
    VideoCrawlerTagExample,
    FormFooter,
  },
  data() {
    return {
      state: {
        isLoading: false,
        readyToSave: false,
        isSaved: false,
      },
      payload: {
        title: {
          tag: 'h1',
          attributeKey: '',
          attributeValue: '',
        },
        subTitle: {
          tag: 'h2',
          attributeKey: '',
          attributeValue: '',
        },
        coverImageUrl: {
          tag: 'meta',
          attributeKey: '',
          attributeValue: '',
        },
      },
      crawler: {},
    };
  },
  computed: {
    titleTag() {
      return this.payload.title.tag;
    },
    subTitleTag() {
      return this.payload.subTitle.tag;
    },
    coverImageUrlTag() {
      return this.payload.coverImageUrl.tag;
    },
    shouldShowCrawlerConfig() {
      return this.project.enabledCrawlerConfiguration;
    },
  },
  watch: {
    titleTag() {
      this.setNotReadyToSave();
    },
    subTitleTag() {
      this.setNotReadyToSave();
    },
    coverImageUrlTag() {
      this.setNotReadyToSave();
    },
  },
  created() {
    this.crawler = this.initialCrawler;
    this.mapCrawlAttributesToPayload();
  },
  methods: {
    mapCrawlAttributesToPayload() {
      const payload = {};
      _.forEach(this.crawler.crawlAttributes, (crawler) => {
        const crawlerKeys = Object.keys(crawler);
        const tag = crawlerKeys[crawlerKeys.findIndex(item => item !== 'name')];
        const attribute = crawler[tag];
        if (!attribute) {
          Object.assign(payload, tag);
        } else {
          const attributeKey = Object.keys(attribute)[0];
          const attributeValue = attribute[attributeKey];
          Object.assign(payload, {
            [crawler.name]: {
              tag,
              attributeKey,
              attributeValue,
            },
          });
        }
      });
      Object.assign(this.payload, payload);
    },
    mapPayloadToCrawlAttributes() {
      const crawlAttributes = [];
      _.forEach(this.payload, (p, pKey) => {
        const crawler = {};
        Object.assign(crawler, {
          name: pKey,
        });
        Object.assign(crawler, { [p.tag]: {} });
        if (p.attributeKey !== '' && p.attributeValue !== '') {
          Object.assign(crawler[p.tag], {
            [p.attributeKey]: p.attributeValue,
          });
        }
        crawlAttributes.push(crawler);
      });
      Object.assign(this.crawler, { crawlAttributes });
    },
    setReadyToSave() {
      this.state.readyToSave = true;
    },
    setNotReadyToSave() {
      this.state.readyToSave = false;
    },
    onChangeTitle(event) {
      const { name, value } = event.target;
      Object.assign(this.payload.title, { [name]: value });
      this.setNotReadyToSave();
    },
    onChangeSubtitle(event) {
      const { name, value } = event.target;
      Object.assign(this.payload.subTitle, { [name]: value });
      this.setNotReadyToSave();
    },
    onChangeCoverImageUrl(event) {
      const { name, value } = event.target;
      Object.assign(this.payload.coverImageUrl, { [name]: value });
      this.setNotReadyToSave();
    },
    async onSaveCrawler() {
      this.state.isSaved = false;
      const response = await editCrawlerSettings(this.project.projectId, this.crawler);
      this.state.isSaved = true;
      this.crawler = response.data.crawler;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.config-group:not(:first-child) {
  margin-top: $spacer * 1.5;
}

.crawler-testing-container {
  margin-top: $spacer * 3;
}
</style>
